export const get_notifications = (state) => state.notifications;

export const get_notification_count = (state) => state.notification_count;

export const get_notification_count_seen = (state) =>
  state.notification_count_seen;

export const get_notification_count_unseen = (state) =>
  state.notification_count - state.notification_count_seen;
